import { type MaybeRefOrGetter, toValue } from "vue";
import type { TripRouteStop, TripStop } from "@/types/trip";
import { getFreightOrdinalLabel as getLabel } from "@/utils/freightOrdinals";

export function useFreightOrdinals(tripStops: MaybeRefOrGetter<(TripStop | TripRouteStop)[]>) {
  function getFreightOrdinalLabel(freightId: string | undefined): string | null {
    return getLabel(toValue(tripStops), freightId);
  }

  return {
    getFreightOrdinalLabel,
  };
}
